export default function AmerLabel({ inputId, value, bold, required }) {
    return (
        <>
            {value && (
                <label
                    htmlFor={inputId}
                    style={{
                        fontSize: ".8rem",
                        color: "#606061",
                        fontWeight: bold ? 600 : 500
                    }}
                >
                    {value}
                    {required && <span style={{ color: "#BF211E" }}> *</span>}
                </label>
            )}
        </>
    )
}